var MIN_SCALE = 0.5;
var MAX_SCALE = 5;
var RESTORE_THRESHOLD = 0.3;

function getDistance(t1, t2) {
  var dx = t1.clientX - t2.clientX;
  var dy = t1.clientY - t2.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

function createInitialState() {
  return {
    mode: null,
    initialDistance: 0,
    initialScale: 1,
    baseScale: 1,
    baseTranslateX: 0,
    baseTranslateY: 0,
    startTouchX: 0,
    startTouchY: 0,
    moved: false,
    currentTX: 0,
    currentTY: 0
  };
}

function buildTransform(scale, tx, ty) {
  return 'scale(' + scale + ') translate(' + tx + 'px, ' + ty + 'px)';
}

var INITIAL_TRANSFORM = buildTransform(1, 0, 0);

function createPinchZoomHandler(options) {
  var onChange = options.onChange || function() {};
  var minScale = options.minScale !== undefined ? options.minScale : MIN_SCALE;
  var maxScale = options.maxScale !== undefined ? options.maxScale : MAX_SCALE;
  var restoreThreshold = options.restoreThreshold !== undefined ? options.restoreThreshold : RESTORE_THRESHOLD;

  var state = createInitialState();

  function emit(scale, tx, ty) {
    onChange(buildTransform(scale, tx, ty));
  }

  return {
    touchStart: function(e) {
      var touches = e.touches;
      state.moved = false;

      if (touches.length === 2) {
        e.preventDefault();
        state.mode = 'pinch';
        state.initialDistance = getDistance(touches[0], touches[1]);
        state.baseScale = state.initialScale;
      } else if (touches.length === 1) {
        state.mode = 'drag';
        state.startTouchX = touches[0].clientX;
        state.startTouchY = touches[0].clientY;
        state.baseTranslateX = state.currentTX;
        state.baseTranslateY = state.currentTY;
      }
    },

    touchMove: function(e) {
      e.preventDefault();
      var touches = e.touches;

      if (state.mode === 'pinch' && touches.length === 2) {
        state.moved = true;
        var newDist = getDistance(touches[0], touches[1]);
        var scale = Math.min(maxScale, Math.max(minScale, state.baseScale * (newDist / state.initialDistance)));
        state.initialScale = scale;
        emit(scale, state.baseTranslateX, state.baseTranslateY);
      } else if (state.mode === 'drag' && touches.length === 1) {
        state.moved = true;
        var dx = touches[0].clientX - state.startTouchX;
        var dy = touches[0].clientY - state.startTouchY;
        var tx = state.baseTranslateX + dx / state.initialScale;
        var ty = state.baseTranslateY + dy / state.initialScale;
        state.currentTX = tx;
        state.currentTY = ty;
        emit(state.initialScale, tx, ty);
      }
    },

    touchEnd: function(e) {
      if (state.mode === 'pinch' && e.touches.length < 2) {
        state.mode = e.touches.length === 1 ? 'drag' : null;
        if (e.touches.length === 1) {
          state.startTouchX = e.touches[0].clientX;
          state.startTouchY = e.touches[0].clientY;
          state.baseTranslateX = state.currentTX;
          state.baseTranslateY = state.currentTY;
        }
        return;
      }
      if (state.initialScale > 1 + restoreThreshold || state.initialScale < 1 - restoreThreshold) {
        return;
      }
      state.initialScale = 1;
      state.baseTranslateX = 0;
      state.baseTranslateY = 0;
      state.currentTX = 0;
      state.currentTY = 0;
      emit(1, 0, 0);
    },

    getInitialTransform: function() {
      return INITIAL_TRANSFORM;
    },

    isMoved: function() {
      return state.moved;
    },

    clearMoved: function() {
      state.moved = false;
    },

    reset: function() {
      state = createInitialState();
    }
  };
}

export default createPinchZoomHandler;
